var _rect, _path, _circle, _path2, _circle2, _rect2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationMobileOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.98,
    y: 1.699,
    width: 11.343,
    height: 20.6,
    rx: 1.598,
    fill: "#F6F7F9",
    stroke: "#F44336"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.41h7.997M4.973 18.977h11.602M15.465 4.41h.864",
    stroke: "#F44336",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.713,
    cy: 20.639,
    r: 0.799,
    stroke: "#F44336",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.136 10.58c0 .507-.198 1.149-.559 1.88-.356.722-.85 1.486-1.387 2.224-1.064 1.46-2.273 2.773-2.861 3.388-.588-.615-1.797-1.929-2.861-3.388-.538-.738-1.03-1.502-1.387-2.224-.362-.732-.56-1.373-.56-1.88a4.807 4.807 0 1 1 9.615 0z",
    fill: "#F6F7F9",
    stroke: "#F44336"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.33,
    cy: 10.207,
    r: 2.098,
    stroke: "#F44336",
    strokeWidth: 0.741
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 5,
    width: 32,
    height: 14,
    rx: 4,
    fill: "#E74C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.195 15.09c-.687 0-1.283-.147-1.79-.44a2.952 2.952 0 0 1-1.16-1.26c-.273-.547-.41-1.187-.41-1.92 0-.733.133-1.37.4-1.91a2.934 2.934 0 0 1 1.17-1.26c.507-.293 1.103-.44 1.79-.44s1.28.147 1.78.44c.507.293.893.713 1.16 1.26.273.54.41 1.177.41 1.91 0 .733-.137 1.373-.41 1.92a2.935 2.935 0 0 1-1.17 1.26c-.5.293-1.09.44-1.77.44zm0-1.03c.647 0 1.15-.223 1.51-.67.367-.447.55-1.087.55-1.92s-.183-1.47-.55-1.91c-.36-.447-.863-.67-1.51-.67-.653 0-1.163.223-1.53.67-.36.44-.54 1.077-.54 1.91s.18 1.473.54 1.92c.367.447.877.67 1.53.67zm5.437 1a.636.636 0 0 1-.47-.18.657.657 0 0 1-.17-.47V8.56c0-.193.054-.343.16-.45.114-.107.267-.16.46-.16h3.51c.407 0 .61.173.61.52 0 .34-.203.51-.61.51h-2.86v1.92h2.66c.407 0 .61.173.61.52 0 .34-.203.51-.61.51h-2.66v2.48c0 .193-.056.35-.17.47a.602.602 0 0 1-.46.18zm5.809 0a.636.636 0 0 1-.47-.18.656.656 0 0 1-.17-.47V8.56c0-.193.053-.343.16-.45.113-.107.267-.16.46-.16h3.51c.407 0 .61.173.61.52 0 .34-.203.51-.61.51h-2.86v1.92h2.66c.407 0 .61.173.61.52 0 .34-.203.51-.61.51h-2.66v2.48c0 .193-.057.35-.17.47a.603.603 0 0 1-.46.18z",
    fill: "#F6F7F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMobileOff);
export default __webpack_public_path__ + "static/media/location-mobile-off.6bff3ebe.svg";
export { ForwardRef as ReactComponent };